import React, { useState, useEffect, useRef } from "react";
// import { ReactDOM } from "react";
import styles from "./embed.module.css";
const Embed = () => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const titleRef = useRef(null);
    const requestRef = useRef();

    useEffect(() => {
        const handleScroll = () => {
            requestRef.current = requestAnimationFrame(() => {
                const titleTop = titleRef.current.offsetTop;
                const titleHeight = titleRef.current.offsetHeight;
                const scrollTop = window.scrollY;
                const scrollBottom = scrollTop + window.innerHeight;

                // check if the title is in view
                if (scrollTop < titleTop + titleHeight && scrollBottom > titleTop) {
                    const progress = (scrollBottom - titleTop) / (titleHeight + window.innerHeight);
                    setScrollPosition(progress);
                } else {
                    setScrollPosition(0);
                }
            });
        }
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            cancelAnimationFrame(requestRef.current);
        };
    }, []);

    const titleStyle = {
        background: `linear-gradient(to left, #5618C5 ${scrollPosition * 180}%, #FFF ${scrollPosition * 180}%)`,
      };

    return (
        <div className={styles.containerEmbed}>
            <div className={styles.contents}>
                <h1 ref={titleRef} className={styles.videoTitle} style={titleStyle} >
                    اینجا چه خبره؟
                </h1>
                <p className={styles.videoParagraph}>
                هلیوم پارک پر از بازی‌های منحصر به فرد و جذابه، بازی‌هایی که شما رو به بیشتر پریدن، بلندتر خندیدن و تحرک و شادی وادار می‌کنه. سن و سال مهم نیست، اینجا می‌تونید از سستی و کرختی فاصله بگیرید و یه فعالیت بدنی سالم و مهیج داشته باشید. هدف ما ایجاد محیطی پویا و پرنشاط برای تمام اعضای خانواده است، جایی که در اون خاطرات به یادموندنی ساخته میشه. پس روی انواع ترامپولین (صفحه‌های فنری که میشه روی اون‌ها چند متر بپرید) بازی کنید و از بسکتبال، والیبال و وسط‌تنها روی ترامپولین لذت ببرید. به جز این‌ها کلی تفریح حرکتی دیگه مثل صخره‌نوردی، فوتبال در حباب، مسیر نینجا و... هم داریم. همچنین می‌تونید کودکان‌تون رو برای بازی، به محوطه اختصاصی زیر 5 سال بیارید. در هلیوم پارک رستوران، کافی‌شاپ، سالن تولد و دورهمی و فضای نشستن برای والدین هم وجود داره تا بدون دغدغه در این‌جا کنار هم باشیم.
                </p>
            </div>
            <video className={styles.videoplayer} controls>
                <source src="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/Ende Ende Digemp4-1.m4v " type="video/mp4" />
            </video>
        </div>
    )
};
export default Embed